import React from 'react';
        export default class DistributionSection extends React.Component {
        render() {
        return (
<section id="distribution-section" className="section distribution-section distribution  d-flex align-items-center text-center">
    <div className="container">
        <h2>
            <span className="white">Distribution</span>
            <span className="darkred">Delivery</span>
        </h2>
        <p>
            At CP Food Service we have a fleet of dedicated vehicles on the road servicing customers who operate restaurants, cafés, hotels, clubs, supermarkets, wholesalers and more. We deliver to the Sydney Metropolitan area five days per week and also service customers between Newcastle, Penrith and Wollongong on a weekly basis. 
        </p>
        <img alt="Map" className="map-img" src="/img/mapupdated.jpg" />
        <div className="distribution-box">
            <h2 className="white">HOW IT WORKS</h2>
            <ul className="d-flex">
                <li>
                    <h4>Order </h4>
                    <img alt="Order" src="/img/online-order.svg" />
                    <p>
                        Customer places order via telephone, email or fax
                    </p>
                </li>
                <li>
                    <h4>Processing </h4>
                    <img alt="Processing" src="/img/business.svg" />
                    <p>
                        Order is generated into an invoice and packing slip
                    </p>
                </li>
                <li>
                    <h4>Packing </h4>
                    <img alt="Packing" src="/img/package-for-delivery.svg" />

                    <p>
                        Products are packed to order
                    </p>
                </li>
                <li>
                    <h4>Delivery </h4>
                    <img alt="Delivery" src="/img/logistics-delivery-truck-in-movement.svg" />
                    <p>
                        Goods on board for delivery to customer
                    </p>
                </li>
                <li>
                    <h4>Optional: Pick Up </h4>
                     <img alt="Pick Up" src="/img/pickup.svg" />
                    <p>
                        Customer can request pick up from warehouse
                    </p>
                </li>
            </ul>
        </div>
    </div>
</section>
                )
        }
        }



// WEBPACK FOOTER //
// ./src/components/Home/Distribution-Section.js